import React, { useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { search } from '../../actions/search';
import styles from './GraphUsersTypeAhead.style';
import SearchBar from '../../components/SearchBar';

const GraphUsersTypeAhead = ({
  field: { name, value = null },
  form: { errors = {}, setFieldValue = () => {}, setFieldTouched = () => {} },
  label,
  required,
  dataTestId,
  ...other
}) => {
  const setFormValue = val => {
    setFieldValue(name, val);
    setFieldTouched(name);
  };

  const errorMessage = get(errors, name);

  const dispatch = useDispatch();
  const [selectedUser, setselectedUser] = useState(value);
  const [showUserSuggestions, setShowUserSuggestions] = useState(true);
  const suggestions = useSelector(state => get(state, 'search.results'));
  const [isLoading, setIsLoading] = useState(true);
  const searchSuggestions = get(suggestions, 'graphUsers', [])
    .map(user => ({
      icon: 'Contact',
      value: user,
      label: user.displayName,
    }))
    .slice(0, 10);

  const getSuggestions = () => {
    if (!showUserSuggestions) {
      return null;
    }
    return searchSuggestions;
  };

  const onTypeAction = async newInput => {
    if (!newInput) return;
    setIsLoading(true);
    await dispatch(search(['graphUsers'], newInput));
    setShowUserSuggestions(true);
    setIsLoading(false);
  };

  const onUserSelection = user => {
    setselectedUser(user.value);
    setFormValue(user.value);
    setShowUserSuggestions(false);
  };

  const handleClear = () => {
    setselectedUser('');
    setFormValue('');
  };

  return (
    <Stack>
      {label && (
        <Stack horizontal verticalAlign="start">
          <Label data-testid="typeahead-label">{label}</Label>
          {required && <Text className={styles.asterisk}>*</Text>}
        </Stack>
      )}

      <SearchBar
        placeholder="Search user"
        ariaLabel="Search"
        underlined={false}
        name="user-search"
        onClick={onUserSelection}
        value={selectedUser?.displayName}
        onChange={onTypeAction}
        onClear={handleClear}
        suggestions={getSuggestions()}
        isLoading={isLoading}
        aria-required={required}
        data-testid={dataTestId}
        {...other}
      />

      {errorMessage && (
        <div role="alert">
          <p className={styles.errorMessage}>
            <span data-testid="typeahead-required" data-automation-id="error-message">
              {errorMessage}
            </span>
          </p>
        </div>
      )}
    </Stack>
  );
};

GraphUsersTypeAhead.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.object,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({}),
    setFieldTouched: PropTypes.func,
    setFieldValue: () => {},
  }),
  label: PropTypes.string,
  required: PropTypes.bool,
  dataTestId: PropTypes.string,
};

GraphUsersTypeAhead.defaultProps = {
  form: {
    errors: {},
    setFieldTouched: () => {},
    setFieldValue: () => {},
  },
  required: false,
  label: null,
  dataTestId: 'user-search',
};

export default GraphUsersTypeAhead;
